(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.getAttribute('data-ready')) return;
      root.setAttribute('data-ready', '1');
      var list = root.querySelector('[data-announce-list]');
      var items = list ? Array.prototype.slice.call(list.children) : [];
      if (!items.length) return;
      var prev = root.querySelector('[data-announce-prev]');
      var next = root.querySelector('[data-announce-next]');
      var interval = Math.max(3000, Number(root.getAttribute('data-interval')) || 5000);
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var idx = 0, timer = null, hold = false, hover = false, focus = false;
      items.forEach(function (el, i) { if (el.classList.contains('is-active')) idx = i; });
      function show(i) {
        idx = (i + items.length) % items.length;
        items.forEach(function (el, n) {
          var on = n === idx;
          el.classList.toggle('is-active', on);
          if (on) { el.removeAttribute('aria-hidden'); el.removeAttribute('inert'); }
          else { el.setAttribute('aria-hidden', 'true'); el.setAttribute('inert', ''); }
        });
      }
      function canPlay() { return items.length > 1 && !reduce && !hold && !hover && !focus && !document.hidden && root.isConnected; }
      function schedule() {
        clearTimeout(timer); timer = null;
        if (canPlay()) timer = setTimeout(function () { timer = null; if (!root.isConnected) return; if (canPlay()) show(idx + 1); schedule(); }, interval);
      }
      show(idx);
      if (items.length > 1) { if (prev) prev.hidden = false; if (next) next.hidden = false; }
      if (prev) prev.addEventListener('click', function () { show(idx - 1); schedule(); });
      if (next) next.addEventListener('click', function () { show(idx + 1); schedule(); });
      root.addEventListener('mouseenter', function () { hover = true; schedule(); });
      root.addEventListener('mouseleave', function () { hover = false; schedule(); });
      root.addEventListener('focusin', function (e) { focus = !!(e.target.matches && e.target.matches(':focus-visible')); schedule(); });
      root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) { focus = false; schedule(); } });
      document.addEventListener('visibilitychange', schedule);
      // theme editor: show the message being edited and keep it still
      root.addEventListener('shopify:block:select', function (e) { hold = true; var i = items.indexOf(e.target); if (i > -1) show(i); schedule(); });
      root.addEventListener('shopify:block:deselect', function () { hold = false; schedule(); });
      schedule();
    }
    function start() { Array.prototype.forEach.call(document.querySelectorAll('[data-announce]'), init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
    document.addEventListener('shopify:section:load', function (e) { Array.prototype.forEach.call(e.target.querySelectorAll('[data-announce]'), init); });
  })();

  } catch(e) { console.error(e); }
})();
})();
